export default {
  common: {
    // 验证
    validates: {
      input_required: '请输入{0}',
      select_required: '请选择{0}',
      length: '输入长度在 {0} 到 {1} 个字符',
      size: '输入{0} ~ {1} 区间的值',
      invalid_email: '邮箱格式不正确'
    },
    // 按钮
    btn: {
      create: '新建',
      delete: '删除',
      edit: '编辑',
      export: '导出',
      reset: '重置',
      update: '更新',
      confirm: '确认',
      cancel: '取消',
      save: '保存',
      new: '添加',
      view: '查看',
      refresh: '刷新',
      select: '选择',
      copy: '复制',
      upload: '上传',
      setting: '设置',
      pass: '审核通过',
      reject: '拒绝',
      transfer: '转账',
      view_ip: '查看IP',
      sorting: '排序',
      statistics: '统计数据',
      add: '添加',
      operation: '操作',
      submit: '提交',
      download: '下载',
      select_file: '选择文件',
      save_info: '保存信息',
      actived: '激活',
      detail: '明细',
      close: '关闭'
    },
    // 面包屑
    breadcrumb: {
      list: '{0}列表',
      new: '新建{0}',
      detail: '{0}详情',
      edit: '编辑{0}'
    },
    labels: {
      list: '列表',
      detail: '详情',
      keyword: '关键词'
    },
    toast: {
      update_success: '更新成功',
      delete_success: '删除成功'
    },
    true: '是',
    false: '否',
    not_authorization: '没有权限',
    refresh: '刷新',
    save: '保存',
    data_much: '导出的数据超过了最大限制 {0} 条',
    tiao: '条',
    no_label: '没标签',
    no_options: '选择列表为空',
    loading: '加载中…',
    upload: '上传中',
    loading_text: '请求中...',
    close: '关闭',
    export_excel: '导出 Excel',
    is_exporting: '导出中...',
    is_importing: '导入中...',
    operation: '操作',
    no_data: '没有数据',
    all: '全部',
    datetime: '日期',
    selectall: '全选',
    not_limit: '不限',
    title: {
      new: '添加{0}'
    },
    success: {
      deleted: '删除{0}成功',
      created: '创建{0}成功',
      edited: '编辑{0}成功',
      updated: '更新{0}成功',
      saved: '保存{0}成功',
      uploaded: '上传{0}成功',
      actived: '激活{0}成功'
    },
    fail: {
      deleted: '删除{0}失败'
    },
    cancel: '取消',
    back: '返回',
    confirm: '确认',
    update_message: {
      success: '编辑成功',
      fail: '编辑失败'
    },
    unit: {
      second: '秒',
      jian: '件',
      day: '天',
      yuan: '元',
      dollar: '元',
      degree: '度',
      kwh: 'kWh',
      kwh_cn: '度',
      kw: 'kW',
      times: '次',
      person: '人',
      quantity: '个',
      sheet: '张',
      minute: '分钟',
      hour: '小时',
      electricity_price: '元/度',
      bi: '笔',
      ten_thousand_yuan: '万元',
      month_label: '月份',
      month: '月',
      power: 'kW',
      voltage: 'V',
      current: 'A',
      gun: '枪',
      currency: '￥',
      order: '笔',
      meter: '米',
      percent: '%',
      count: '条'
    },
    fail_to_get_data: '获取数据失败',
    validate: {
      number: '请输入合法的数字'
    },
    please_select: '请选择',
    titles: {
      flowchart: '流程指引',
      transition_history: '审核历史'
    },
    tips: {
      copy_success: '已复制内容到粘贴板',
      copy_fail: '无法复制内容，请手动选择复制'
    },
    boolean_values: {
      true: '是',
      false: '否'
    },
    weeks: {
      '0': '日',
      '1': '一',
      '2': '二',
      '3': '三',
      '4': '四',
      '5': '五',
      '6': '六'
    },
    android_download_tip: {
      sp_android_version: '移动运营端安卓版本',
      download_btn: '立即下载'
    }
  }
}
